// extracted by mini-css-extract-plugin
module.exports = {"cpCoverPhoto":"cpCoverPhoto_cpCoverPhoto__ccXlp","imgBox":"cpCoverPhoto_imgBox___5Xlj"};